function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cn from 'classnames';
import { Typography, Button } from 'seagull';
import { KycCompletionStatus } from "../../../store/store.model";
import styles from "./BusinessOnboardingWidget.module.scss";
import SetUpBrand from "./steps/SetUpBrand/SetUpBrand";
import SetupServices from "./steps/SetupServices";
import TestAgreement from "./steps/TestAgreement/TestAgreement";
import ConnectBankAccount from "./steps/ConnectBankAccount/ConnectBankAccount";
import CompleteKYC from "./steps/CompleteKYC/CompleteKYC";
import { KYBProgressStatusEnum } from 'anchor-kyb-service/types';
import TutorialVideos from "./steps/TutorialVideos/TutorialVideos";
import { selectors } from "../../../store/state-selectors";
export const Box = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.box, className)
  }, children);
};
export const StepTitle = _ref2 => {
  let {
    children,
    spacing = 'normal'
  } = _ref2;
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles[spacing + 'Spacing'],
    weight: "normal",
    variant: "h6"
  }, children);
};
export const StepSubtitle = _ref3 => {
  let {
    children,
    spacing = 'normal'
  } = _ref3;
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles[spacing + 'Spacing'],
    variant: "paragraph1"
  }, children);
};
export const StepHelperText = _ref4 => {
  let {
    children,
    spacing = 'normal'
  } = _ref4;
  return /*#__PURE__*/React.createElement(Typography, {
    className: styles[spacing + 'Spacing'],
    variant: "paragraph2",
    skin: "secondary"
  }, children);
};
export const ActionButton = props => {
  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "medium"
  }, props));
};
export function StepLayout(props) {
  const {
    id,
    title,
    subtitle,
    actions,
    icon
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.stepLayout,
    "data-testid": "onboarding-widget-content-".concat(id)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StepTitle, null, title), /*#__PURE__*/React.createElement(StepSubtitle, null, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, actions)), /*#__PURE__*/React.createElement("div", null, icon));
}
export function getKycWarning(worksAt, wasKYBApprovedDuringLast5Minutes) {
  const {
    kycCompletionStatus
  } = worksAt || {};
  if (kycCompletionStatus === KycCompletionStatus.CompletedWithFutureRequirements) {
    return {
      testid: 'kyc-future-requirements',
      text: 'To avoid an interruption in charges and payouts, additional information is required'
    };
  } else if (kycCompletionStatus === KycCompletionStatus.Incomplete && !wasKYBApprovedDuringLast5Minutes) {
    return {
      testid: 'onboarding-kyc-error',
      text: 'Additional information is required to verify your business identity and enable payouts'
    };
  } else {
    return null;
  }
}
export const getStepsInfo = _ref5 => {
  var _numSampleAgreements$, _numSampleAgreements$2;
  let {
    userInfo,
    modifiedAServiceTemplate,
    isMemberUser,
    startKyc,
    personaKYBStatus,
    videos,
    hasSentAProposal,
    EXPOSE_BANK_ACCOUNT
  } = _ref5;
  const {
    numSampleAgreements,
    logoUrl
  } = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.worksAt) || {};
  const totalSampleAgreements = ((_numSampleAgreements$ = numSampleAgreements === null || numSampleAgreements === void 0 ? void 0 : numSampleAgreements.approved) !== null && _numSampleAgreements$ !== void 0 ? _numSampleAgreements$ : 0) + ((_numSampleAgreements$2 = numSampleAgreements === null || numSampleAgreements === void 0 ? void 0 : numSampleAgreements.pending) !== null && _numSampleAgreements$2 !== void 0 ? _numSampleAgreements$2 : 0);
  const isConnectBankAccountStepComplete = (EXPOSE_BANK_ACCOUNT ? selectors.user.hasBankAccountConnected : selectors.user.hasLinkedBankAccount)({
    userInfo: userInfo || null
  });
  const isKycStepComplete = personaKYBStatus === KYBProgressStatusEnum.Approved;
  const steps = [{
    id: 'brand',
    label: 'Set up your brand',
    complete: !!logoUrl,
    minutes: 1,
    component: SetUpBrand
  }, {
    id: 'setupServices',
    label: 'Set up services',
    complete: modifiedAServiceTemplate,
    minutes: 2,
    component: SetupServices,
    hide: isMemberUser
  }, {
    id: 'testAgreement',
    label: 'Send a test agreement',
    complete: totalSampleAgreements > 0 || hasSentAProposal,
    minutes: 5,
    component: TestAgreement
  }, {
    id: 'connectBankAccount',
    label: 'Connect bank account',
    complete: isConnectBankAccountStepComplete,
    minutes: 1,
    component: ConnectBankAccount
  }, {
    id: 'kyc',
    label: 'Verify your business identity',
    complete: isKycStepComplete,
    minutes: 3,
    component: CompleteKYC,
    extraProps: {
      startKyc,
      isUnderReview: personaKYBStatus === KYBProgressStatusEnum.AwaitingDecision
    }
  }, {
    id: 'tutorialVideos',
    label: 'Watch tutorial videos',
    complete: Object.values(videos).filter(_ref6 => {
      let {
        watched
      } = _ref6;
      return watched;
    }).length >= 4,
    component: TutorialVideos
  }];
  return {
    steps,
    isRequiredStepsCompleted: isConnectBankAccountStepComplete && isKycStepComplete,
    numCompleted: steps.filter(s => s.complete).length
  };
};